import { DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

interface AvatarPlaceholderWrapperProps {
  backgroundColor?: string
}

export const AvatarPlaceholderWrapper = styled.div<AvatarPlaceholderWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ backgroundColor }) => backgroundColor};
`
